import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { GradeService } from '../_services/grades.service';
import { RoutesService } from 'src/app/buses/_services/routes.service';
import { StaffService } from '../_services/staff.service';
import { StudentService } from 'src/app/user-management/_services/student.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ClassStudentsService } from '../_services/class-students.service';
import { DataService } from 'src/app/dashboard/_services/data.service';

declare var $: any;

@Component({
  selector: 'app-class-students-teachers-list',
  templateUrl: './class-students-teachers-list.component.html',
  styleUrls: ['./class-students-teachers-list.component.scss']
})
export class ClassStudentsTeachersListComponent implements OnInit {
  dataArray: any = [];
  studentsDataArray: any = [];
  clazz;
  tableControls: any = { data: [] };
  studentsTableControls: any = { data: [] };
  classStudents = [];
  classTeachers = [];
  selectedClassTeachers = [];
  showTeachersDropdown = false;
  currLang;
  allStudentsSelfCheckoutFlag;
  allStudentsSelfCheckoutOptions = [
    { label: 'grades-classes.grades-classes-modal.yes', value: 'yes' },
    { label: 'grades-classes.grades-classes-modal.no', value: 'no' },
    { label: 'grades-classes.grades-classes-modal.custom', value: "custom" },
  ]
  baseUrl = environment.img_url;
  loading = false;
  @ViewChild("assignedTeachers") assignedTeachers: ElementRef;


  constructor(private gradesService: GradeService,
    private routesService: RoutesService,
    private staffService: StaffService,
    private globalService: GlobalService,
    private translate: TranslateService,
    private studentService: StudentService,
    private container: ElementRef,
    private ClassStudentsService: ClassStudentsService,
    private dataService: DataService,) {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
  }

  @HostListener("click", ["$event.target"]) onClick(event) {
    const parent = this.assignedTeachers.nativeElement;
    if (!parent.contains(event)) {
      this.showTeachersDropdown = false;
    }
  }


  ngOnInit(): void {
    this.globalService.getLang().subscribe(lng => {
      this.currLang = lng;
      this.translate.use(this.currLang);
    });
    this.routesService.disableCheckAllBtn();
    this.gradesService.getClassData().subscribe(res => {
      if (res !== null) {
        this.clazz = res;
        this.classTeachers = [];
        this.selectedClassTeachers = [];
        let studentDataArray = [];
        res["students"].forEach(element => {
          studentDataArray.push({
            class_id: element.class_id,
            gender: element.gender,
            id: element.id,
            image_path: element.image_path,
            is_active: element.is_active,
            joined_bus: element.joined_bus,
            name: element.name,
            national_id: element.national_id,
            route_id: element.route_id,
            school_confirmed: element.school_confirmed,
            school_id: element.school_id,
            student_can_self_checkout: element.student_can_self_checkout ? true : false,
          })
        });
        this.studentsDataArray = studentDataArray;
        this.checkAllStudentsSelfPermission(this.studentsDataArray);
        res["teachers"].forEach(element => {
          this.classTeachers.push(element.name);
        });
        // the selected teachers in the dropdown input
        this.selectedClassTeachers = this.classTeachers.slice(0, 3);
      }
    })
  }

  onAllStudentsSelfChanged(event) {
    if (event.value == 'yes') {
      this.studentsDataArray.forEach(student => {
        student.student_can_self_checkout = true;
      });
    }
    else if (event.value == 'no') {
      this.studentsDataArray.forEach(student => {
        student.student_can_self_checkout = false;
      });
    }
  }

  switchStudentSelfPermission(student) {
    student.student_can_self_checkout = !student.student_can_self_checkout;
    this.checkAllStudentsSelfPermission(this.studentsDataArray);
  }
  checkAllStudentsSelfPermission(data) {
    const values = data.map(obj => obj.student_can_self_checkout);
    const allTrue = values.every(value => value === true);
    const allFalse = values.every(value => value === false);
    const custom = !allTrue && !allFalse;

    if (allTrue) {
      this.allStudentsSelfCheckoutFlag = 'yes';
      return 'yes';
    } else if (allFalse) {
      this.allStudentsSelfCheckoutFlag = 'no';
      return 'no';
    } else {
      this.allStudentsSelfCheckoutFlag = 'custom';
      return 'custom';
    }
  }

  save() {
    this.loading = true;
    let tempArray = [];
    let tempObj: any = {};
    tempArray = this.studentsDataArray.map(element => (
      {
        id: element.id,
        student_can_self_checkout: element.student_can_self_checkout
      }
    ))
    tempObj.students = tempArray;
    this.ClassStudentsService.saveStudentsSelfcheckout(tempObj).subscribe(res => {
      this.dataService.updateGradesCache$().subscribe(() => {
        this.cancelModalHandler();
      })
    })
  }


  cancelModalHandler() {
    this.loading = false;
    $("#classListing").modal("hide");
  }
}
